export interface LoginAPIRequest {
  username: string
  password: string
  recaptchaToken?: string
}

export interface CreateAccountAPIRequest {
  username: string
  password: string
  newsletterSun: boolean
  newsletterSki: boolean
  recaptchaToken?: string
}

export interface ResetPasswordAPIRequest {
  username: string
  recaptchaToken?: string
}

export interface SetPasswordAPIRequest {
  token: string
  password: string
  recaptchaToken?: string
}

export interface SetPasswordAPIResponse {
  status?: string
}

export const SET_PASSWORD_API_STATUSES = {
  PASSWORD_SET_AND_SIGNED_IN: 'passwordSetAndSignedIn',
  PASSWORD_SET_BUT_SIGN_IN_FAILED: 'passwordSetButSignInFailed',
}

export interface AutoSignInAPIRequest {
  asit: string
}

export interface VerifyAccountAPIRequest {
  token: string
}

export interface VerifyAccountAPIResponse {
  status?: unknown
  errorCode?: unknown
}

export interface LoginErrorAPIResponse {
  errorCode?: string
  retryAfterSeconds?: number
}

export const LOGIN_API_ERROR_CODES = {
  VALIDATION_FAILED: 'ValidationFailed',
  INVALID_CREDENTIALS: 'InvalidCredentials',
  ACCOUNT_NOT_VERIFIED: 'AccountNotVerified',
  WEAK_PASSWORD: 'WeakPassword',
  RATE_LIMITED: 'RateLimited',
  UNEXPECTED_ERROR: 'UnexpectedError',
}
